import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
import { theme } from '../../themes/theme';
export default css `
    ${componentStyles}
    :host {
        display: inline-block;
    }
    .text-bloc {
        ${theme.texts.cssBody('normal')};
        ${theme.colors.cssColor('text-default')};
        background-color: var(--mode-color-light);
        border-width: var(--sgdf-input-border-width);
        border: solid 1px;
        border-color: var(--mode-color);
        user-select: none;
        cursor: default;
    }

    // reset
    p {
        margin: 0;
    }

    /*
   * Size modifiers
   */
    .text-bloc--small {
        font-size: var(--sgdf-button-font-size-small);
        border-radius: var(--sgdf-input-border-radius-small);
        padding: var(--sgdf-spacing-x-small);
    }

    .text-bloc--medium {
        font-size: var(--sgdf-button-font-size-medium);
        border-radius: var(--sgdf-input-border-radius-medium);
        padding: var(--sgdf-spacing-small);
    }

    .text-bloc--large {
        font-size: var(--sgdf-button-font-size-large);
        border-radius: var(--sgdf-input-border-radius-large);
        padding: var(--sgdf-spacing-medium);
    }
`;
//# sourceMappingURL=text-bloc.styles.js.map